import { render, staticRenderFns } from "./ticketCustomMessage.vue?vue&type=template&id=3dd7ddc4&scoped=true"
import script from "./ticketCustomMessage.vue?vue&type=script&lang=js"
export * from "./ticketCustomMessage.vue?vue&type=script&lang=js"
import style0 from "./ticketCustomMessage.vue?vue&type=style&index=0&id=3dd7ddc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd7ddc4",
  null
  
)

export default component.exports